import script from "./OrdersDetailSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersDetailSection.vue?vue&type=script&setup=true&lang=js"

import "./OrdersDetailSection.vue?vue&type=style&index=0&id=14ad6ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14ad6ce4"]])

export default __exports__